import { Instance, types } from 'mobx-state-tree'
import { ForDirectExtend } from '../mobx'
import Attachment from './Attachment'

const _UserArpMediaStatistics = types.model({
  songMintCount: types.number,
  sampleMintCount: types.number,
  stemMintCount: types.maybe(types.number),
  sampleRemixCount: types.number,
  stemRemixCount: types.number
})

interface UserArpMediaStatisticsType extends ForDirectExtend<typeof _UserArpMediaStatistics> {}
const UserArpMediaStatistics: UserArpMediaStatisticsType = _UserArpMediaStatistics

const _User = types.model({
  walletAddress: types.identifier,
  displayName: types.maybeNull(types.string),
  email: types.maybeNull(types.string),
  bio: types.maybeNull(types.string),
  openSeaHandle: types.maybeNull(types.string),
  twitterHandle: types.maybeNull(types.string),
  soundCloudHandle: types.maybeNull(types.string),
  profilePicture: types.maybeNull(Attachment),
  id: types.number,
  createdAt: types.maybe(types.string),
  updatedAt: types.maybe(types.string),
  arpMediaStatistics: types.maybe(UserArpMediaStatistics)
})

interface UserType extends ForDirectExtend<typeof _User> {}
const User: UserType = _User

export interface IUser extends ForDirectExtend<Instance<typeof User>> {}
export default User
